import {Brick, registerBrick} from 'olympe';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import {isRequesterIncomplete, isSpenderIncomplete} from '../checkMandatoryFields';

/**
 * A brick used to check update of the Status of newly created PR through Mass Creation
 */
export default class UpdatePRCompositeStatus extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} prJSON
     * @param {function()} forwardEvent
     * @param {function(string)} setPrJSON
     */
    update($, [prJSON], [forwardEvent, setPrJSON]) {
        const pr = JSON.parse(prJSON);

        const spenderIncomplete = isSpenderIncomplete(
            pr.spender,
            pr.materials,
            pr.financialInfo.accounts,
            pr.headerDetails.companyCode,
            pr.headerDetails.purchaseOrganization,
            pr.headerDetails.defaultPlant,
            pr.headerDetails.defaultDeliveryAddress,
            pr.headerDetails.defaultRequestedDeliveryDate,
            pr.headerDetails.validityStart,
            pr.headerDetails.validityEnd,
            pr.wayOfBuying,
        );

        const requesterIncomplete = isRequesterIncomplete(
            pr.requester,
            pr.wayOfBuying,
            pr.headerDetails.purchasingGroup,
            pr.materials,
            pr.vendorCode,
            pr.headerDetails.companyCode,
        );
        let newStatus = PurchaseRequest.statuses.saved;

        if (spenderIncomplete && requesterIncomplete) {
            newStatus = PurchaseRequest.statuses.incompleteRequesterAndSpender;
        } else if (spenderIncomplete) {
            newStatus = PurchaseRequest.statuses.incompleteSpender;
        } else if (requesterIncomplete) {
            newStatus = PurchaseRequest.statuses.incompleteRequester;
        }
        pr.status = newStatus;
        setPrJSON(JSON.stringify(pr));
        forwardEvent();
    }
}

registerBrick('01914aaaae53d29e7a6f', UpdatePRCompositeStatus);
